<script lang="ts">
    import {Link} from 'svelte-routing'
    import logo from 'src/components/cabinet/#assets/logo.svg'
    import IconifyIcon from '@iconify/svelte'
    import vestingIcon from '@iconify/icons-fa-solid/lock'
    import listIcon from '@iconify/icons-fa-solid/list'
    import menuIcon from '@iconify/icons-fa-solid/bars'
    import Close from 'src/components/#common/#assets/close.svg'

    let url = window.location.pathname
    let menuOpen = false
</script>
<div class="menu-backdrop" class:active={menuOpen} on:click={() => menuOpen = false}></div>
<button class="hamburger-btn" class:active={menuOpen} on:click={() => menuOpen = true}>
    <IconifyIcon icon={menuIcon}/>
</button>
<div class="leftside-menu" class:active={menuOpen}>
    <Link to="/" class="logo">
        <span class="logo-lg">
            <img src="{logo}" alt="">
        </span>
    </Link>
    <button class="menu-close-btn" class:active={menuOpen} on:click={() => menuOpen = false} style="--Close:url({Close})"></button>
    <div class="h-100 overflow-auto">
        <ul class="side-nav">
            <li class="side-nav-item {url === '/' ? 'menuitem-active' : ''}">
                <Link to="/" class="side-nav-link">
                    <IconifyIcon icon={vestingIcon} class="side-nav-icon"/>
                    <span>Vesting form</span>
                </Link>
            </li>
            <li class="side-nav-item {url === '/history' ? 'menuitem-active' : ''}">
                <Link to="history" class="side-nav-link">
                    <IconifyIcon icon={listIcon} class="side-nav-icon"/>
                    <span>Vesting history</span>
                </Link>
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</div>

<style>
    @import "../../../../styles/global/scrollbar.pcss";

    .overflow-auto {
        @include scrollbar;
        @include scroll-smooth;
    }

    .leftside-menu {
        width: 260px;
        z-index: 10;
        background: #313a46;
        bottom: 0;
        position: fixed;
        top: 0;
        padding-top: 80px;
        -webkit-box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
        box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
    }

    .side-nav-item :global(.side-nav-icon) {
        display: inline-block;
        line-height: 1.0625rem;
        margin: 0 10px 0 0;
        font-size: 1.1rem;
        vertical-align: middle;
        width: 20px;
    }

    .menu-close-btn {
        display: none;
    }

    .menu-arrow :global(svg) {
        font-size: 12px;
    }

    .menuitem-active .menu-arrow :global(svg) {
        transform: rotate(90deg);
    }

    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    .side-nav-second-level li :global(a) {
        padding: 8px 30px 8px 65px;
        color: #8391a2;
        display: block;
        position: relative;
        transition: all .25s;
        font-size: .89rem;
    }

    .side-nav-second-level li :global(a:hover) {
        color: #bccee4;
    }

    .side-nav-second-level li :global(a.active) {
        color: white !important;
    }

    .leftside-menu :global(.logo) {
        display: block;
        line-height: 70px;
        width: 260px;
        position: fixed;
        top: 0;
    }

    .leftside-menu :global(.logo img) {
        width: 120px;
        margin: 12px 0 0 30px;
        display: block;
    }

    .side-nav {
        padding-left: 0;
        list-style-type: none;
    }

    .side-nav :global(.side-nav-link) {
        display: block;
        padding: 10px 30px;
        font-size: .9375rem;
        position: relative;
        -webkit-transition: all .4s;
        transition: all .4s;
        list-style: none;
        color: #8391a2;
    }

    .side-nav :global(.side-nav-link:hover) {
        color: #bccee4;
    }

    .side-nav :global(.side-nav-link > i) {
        display: inline-block;
        line-height: 1.0625rem;
        margin: 0 10px 0 0;
        font-size: 1.1rem;
        vertical-align: middle;
        width: 20px;
    }

    .side-nav :global(.side-nav-link span) {
        vertical-align: middle;
    }

    .side-nav :global(.menu-arrow) {
        transition: transform .15s;
        position: absolute;
        right: 30px;
        display: inline-block;
        text-rendering: auto;
        line-height: 1.5rem;
        font-size: 1.1rem;
        -webkit-transform: translate(0,0);
        transform: translate(0,0);
    }

    .side-nav :global(.menu-arrow i) {
        font-size: 12px;
    }

    .side-nav :global(.collapse:not(.show)) {
        display: none;
    }

    .side-nav :global(.menuitem-active>a) {
        color: #fff!important;
    }

    .hamburger-btn {
        display: none;
    }

    .menu-backdrop {
        display: none;
    }

    .notification-count {
        background: #ff5d1c;
        display: inline-block;
        min-width: 22px;
        padding: 0 3px;
        text-align: center;
        margin-left: 8px;
        border-radius: 3px;
        color: white;
    }

    @media (max-width: 991px) {
        .leftside-menu {
            left: -260px;
            transition: .3s;
        }

        .leftside-menu.active {
            left: 0;
        }

        .hamburger-btn {
            display: block;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 6;
            border: 0;
            padding: 21px 25px;
            background: none;
            font-size: 22px;
            color: #98a6ad;
            line-height: 28px;
            border-right: 1px solid #f1f3fa;
        }

        .menu-backdrop {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.3);
            z-index: 5;
            visibility: hidden;
            opacity: 0;
            transition: opacity .25s;
            cursor: pointer;
        }

        .menu-backdrop.active {
            visibility: visible;
            opacity: 1;
        }

        .leftside-menu .logo img {
            width: 100px;
            margin: 10px 20px 0;
        }

        .menu-close-btn {
            display: block;
            position: absolute;
            top: 15px;
            right: 20px;
            border: 0;
            font-size: 24px;
            color: white;
            background: var(--Close) no-repeat;
            width: 20px;
            height: 20px;
            opacity: 0.8;
            z-index: 2;
        }
    }
</style>
